var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initBundle = /* @__PURE__ */ __name(($el, $refs) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const random_id = utils.shortUUID();
  const bundle_products = (_a = [...$el.querySelectorAll("[data-product-handle][data-product-id]")]) == null ? void 0 : _a.map((element) => ({
    element,
    ..._product.getHtmlProduct(element.getAttribute("data-product-handle"))
  }));
  const sort_values = ["day", "week", "month", "year"];
  const selling_plan_options = (_c = (_b = bundle_products == null ? void 0 : bundle_products.reduce((acc, product, i) => {
    product.variants.forEach((variant) => {
      variant.selling_plan_allocations.forEach((allocation) => {
        acc.push(allocation);
      });
    });
    return acc;
  }, []).filter((a, i, arr) => arr.findIndex((b) => {
    var _a2, _b2;
    return ((_a2 = b == null ? void 0 : b.selling_plan) == null ? void 0 : _a2.name) === ((_b2 = a == null ? void 0 : a.selling_plan) == null ? void 0 : _b2.name);
  }) === i)) == null ? void 0 : _b.sort(
    (a, b) => sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(a.selling_plan.name)) - sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(b.selling_plan.name))
  )) == null ? void 0 : _c.filter((a) => !a.selling_plan.name.toLowerCase().includes("preorder"));
  const section_settings = utils.JSONParse($el.getAttribute("data-section-settings"));
  const select_settings = utils.JSONParse(
    (_d = $el.querySelector("[data-select-settings]")) == null ? void 0 : _d.getAttribute("data-select-settings")
  );
  const bundle_targets = (_e = Array.from($el.querySelectorAll("[data-bundle-target]"))) == null ? void 0 : _e.flatMap(
    (el) => {
      var _a2;
      return (_a2 = utils.JSONParse(
        el.getAttribute("data-bundle-target")
      )) != null ? _a2 : [];
    }
  );
  const initial_bundle_target_id = (_f = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _f.id;
  const initial_target = {
    ...bundle_targets == null ? void 0 : bundle_targets[0]
  };
  bundle_targets == null ? void 0 : bundle_targets.sort((a, b) => {
    var _a2, _b2;
    return ((_a2 = a.settings) == null ? void 0 : _a2.target) - ((_b2 = b == null ? void 0 : b.settings) == null ? void 0 : _b2.target);
  });
  const bundle_target_objects = bundle_targets == null ? void 0 : bundle_targets.reduce((acc, item, i) => {
    acc[item.id] = item.settings;
    return acc;
  }, {});
  const incentive_targets = (_g = Array.from($el.querySelectorAll("[data-bundle-incentive-target]"))) == null ? void 0 : _g.flatMap(
    (el) => {
      var _a2;
      return (_a2 = utils.JSONParse(
        el.getAttribute("data-bundle-incentive-target")
      )) != null ? _a2 : [];
    }
  );
  const bundle_type = section_settings.bundle_target_type;
  const state = window.Alpine.reactive({
    items_added: [],
    bundle_target_titles: [],
    item_added_summary: [],
    bundle_target_id: initial_bundle_target_id,
    total_price: 0,
    discounted_price: 0,
    current_wording: "",
    difference_wording: "",
    target_wording: "",
    final_price: 0,
    subscription_price_before_discounts: 0,
    subscription_price: 0,
    before_discounts_price: 0,
    selling_plan_discount_wording: "",
    selling_plan_discount_wording_old: "",
    target_discount_wording: "",
    active_target_discount_wording: "",
    discount_wording: "",
    active_discount_wording: "",
    item_count: 0,
    target_difference: "",
    selling_plan_options,
    selected_selling_plan: null,
    bundle_target: initial_target == null ? void 0 : initial_target.settings,
    achieved_bundle_target: null,
    incentive_target: incentive_targets == null ? void 0 : incentive_targets[0],
    selling_plan_duration: "",
    isAdding: false,
    items_added_to_cart: false,
    show_mobile_details: false,
    max_bundle_quantity: section_settings.max_bundle_quantity,
    addToBundle: /* @__PURE__ */ __name(() => {
    }, "addToBundle"),
    removeFromBundle: /* @__PURE__ */ __name(() => {
    }, "removeFromBundle")
  });
  const getTargetTitles = /* @__PURE__ */ __name(() => {
    return bundle_targets == null ? void 0 : bundle_targets.map((item) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
      const lowestPrice = Math.min(...bundle_products.map((product) => product.price_min));
      const highestPrice = Math.max(...bundle_products.map((product) => {
        var _a3;
        return (_a3 = product.price_max) != null ? _a3 : product.price;
      }));
      const priceVaries = ((state == null ? void 0 : state.final_price) || lowestPrice) !== ((state == null ? void 0 : state.total_price) || highestPrice);
      return ((_a2 = item.label) == null ? void 0 : _a2.trim()) ? `<span class="flex gap-2 w-full items-center">${utils.unescape(
        (_h = item.label) == null ? void 0 : _h.replace(
          "[price]",
          `<span>${utils.formatMoney(
            (state == null ? void 0 : state.final_price) || (lowestPrice - ((_c2 = (_b2 = item == null ? void 0 : item.settings) == null ? void 0 : _b2.discount_percentage) != null ? _c2 : 0) / 100 * lowestPrice - ((_e2 = (_d2 = item == null ? void 0 : item.settings) == null ? void 0 : _d2.discount_amount) != null ? _e2 : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_f2 = item.settings) == null ? void 0 : _f2.target : 1)
          )}</span>`
        ).replace(
          "[compare_at_price]",
          `<span class="opacity-50 line-through">${utils.formatMoney(
            (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_g2 = item.settings) == null ? void 0 : _g2.target : 1)
          )}</span>`
        )
      )}</span>` : (_z = `<span class="flex items-center gap-2">
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "total_price" && ((_i = item.settings) == null ? void 0 : _i.target) ? `<span>Spend ${utils.formatMoney((_j = item.settings) == null ? void 0 : _j.target)}</span>` : ""}
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? `<span>${(_k = item.settings) == null ? void 0 : _k.target} ${((_l = item.settings) == null ? void 0 : _l.target) === 1 ? "item" : "items"}</span>` : ""}
       ${((_m = item == null ? void 0 : item.settings) == null ? void 0 : _m.discount_percentage) > 0 && ((_n = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _n.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${(_o = item == null ? void 0 : item.settings) == null ? void 0 : _o.discount_percentage}% off</span>` : ""}
       ${((_p = item == null ? void 0 : item.settings) == null ? void 0 : _p.discount_amount) > 0 && ((_q = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _q.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${utils.formatMoney(
        (_r = item == null ? void 0 : item.settings) == null ? void 0 : _r.discount_percentage
      )} off</span>` : ""}
       ${(select_settings == null ? void 0 : select_settings.price_content) ? `<span class="flex-1 flex justify-end gap-2">
           ${(_y = select_settings == null ? void 0 : select_settings.price_content) == null ? void 0 : _y.replace(
        "[price]",
        `<span>${utils.formatMoney(
          (state == null ? void 0 : state.final_price) || (lowestPrice - ((_t = (_s = item == null ? void 0 : item.settings) == null ? void 0 : _s.discount_percentage) != null ? _t : 0) / 100 * lowestPrice - ((_v = (_u = item == null ? void 0 : item.settings) == null ? void 0 : _u.discount_amount) != null ? _v : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_w = item.settings) == null ? void 0 : _w.target : 1)
        )}</span>`
      ).replace(
        "[compare_at_price]",
        priceVaries ? `<span class="opacity-50 line-through">${utils.formatMoney(
          (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_x = item.settings) == null ? void 0 : _x.target : 1)
        )}</span>` : ""
      )}` : ""}
      </span>`) == null ? void 0 : _z.replace(/\n/gi, "").trim();
    });
  }, "getTargetTitles");
  state.bundle_target_titles = getTargetTitles();
  window.Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J;
    state.item_count = (_a2 = state.items_added) == null ? void 0 : _a2.length;
    state.total_price = state.items_added.reduce((acc, item) => {
      var _a3, _b3;
      return acc += (_b3 = item == null ? void 0 : item.price_override) != null ? _b3 : (_a3 = item.variant) == null ? void 0 : _a3.price;
    }, 0);
    state.achieved_bundle_target = (_c2 = (_b2 = [...bundle_targets].sort((a, b) => {
      var _a3, _b3;
      return ((_a3 = b.settings) == null ? void 0 : _a3.target) - ((_b3 = a == null ? void 0 : a.settings) == null ? void 0 : _b3.target);
    })) == null ? void 0 : _b2.find((bundle) => bundle.settings.target <= (state == null ? void 0 : state[bundle_type]))) == null ? void 0 : _c2.settings;
    state.selling_plan_options = (_g2 = (_f2 = (_e2 = state.item_count ? (_d2 = state.items_added) == null ? void 0 : _d2.map(({ product, variant }) => ({ ...product, variants: [variant] })) : bundle_products) == null ? void 0 : _e2.reduce((acc, product, i) => {
      var _a3;
      (_a3 = product.variants) == null ? void 0 : _a3.forEach((variant) => {
        var _a4;
        (_a4 = variant == null ? void 0 : variant.selling_plan_allocations) == null ? void 0 : _a4.forEach((allocation) => {
          acc.push(allocation);
        });
      });
      return acc;
    }, []).filter((a, i, arr) => arr.findIndex((b) => {
      var _a3, _b3;
      return ((_a3 = b == null ? void 0 : b.selling_plan) == null ? void 0 : _a3.name) === ((_b3 = a == null ? void 0 : a.selling_plan) == null ? void 0 : _b3.name);
    }) === i)) == null ? void 0 : _f2.sort(
      (a, b) => sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(a.selling_plan.name)) - sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(b.selling_plan.name))
    )) == null ? void 0 : _g2.filter((a) => !a.selling_plan.name.toLowerCase().includes("preorder"));
    if (state.selected_selling_plan) {
      state.selected_selling_plan = ((_h = state.selling_plan_options) == null ? void 0 : _h.some(
        (item) => item.selling_plan.name === state.selected_selling_plan
      )) ? state.selected_selling_plan : (_j = (_i = selling_plan_options == null ? void 0 : selling_plan_options[0]) == null ? void 0 : _i.selling_plan) == null ? void 0 : _j.name;
    }
    if (!((_k = state.selling_plan_options) == null ? void 0 : _k.length)) {
      state.selected_selling_plan = null;
    }
    const subscription_price = state.items_added.reduce((acc, item) => {
      var _a3, _b3, _c3, _d3, _e3, _f3;
      acc = acc + ((_f3 = (_d3 = item == null ? void 0 : item.price_override) != null ? _d3 : (_c3 = (_b3 = (_a3 = item.variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
        (plan) => {
          var _a4, _b4, _c4, _d4, _e4;
          return ((_a4 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a4.name) === ((_e4 = state.selected_selling_plan) != null ? _e4 : (_d4 = (_c4 = (_b4 = state.selling_plan_options) == null ? void 0 : _b4[0]) == null ? void 0 : _c4.selling_plan) == null ? void 0 : _d4.name);
        }
      )) == null ? void 0 : _c3.price) != null ? _f3 : (_e3 = item.variant) == null ? void 0 : _e3.price);
      return acc;
    }, 0);
    state.discounted_price = state.total_price - ((_m = (_l = state.achieved_bundle_target) == null ? void 0 : _l.discount_amount) != null ? _m : 0) - state.total_price * (((_o = (_n = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _n.discount_percentage) != null ? _o : 0) / 100);
    state.subscription_price_before_discounts = subscription_price;
    state.subscription_price = subscription_price - ((_q = (_p = state.achieved_bundle_target) == null ? void 0 : _p.discount_amount) != null ? _q : 0) - subscription_price * (((_s = (_r = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _r.discount_percentage) != null ? _s : 0) / 100);
    state.before_discounts_price = state.selected_selling_plan ? state.subscription_price_before_discounts : state.total_price;
    state.final_price = state.selected_selling_plan ? state.subscription_price : state.discounted_price;
    state.target_difference = bundle_type === "item_count" ? ((_t = state.bundle_target) == null ? void 0 : _t.target) - state.item_count > 0 ? `${((_u = state.bundle_target) == null ? void 0 : _u.target) - state.item_count}` : "" : ((_v = state.bundle_target) == null ? void 0 : _v.target) - state.total_price ? `${utils.formatMoney(((_w = state.bundle_target) == null ? void 0 : _w.target) - state.item_count)}` : "";
    state.target_wording = bundle_type === "item_count" ? `${(_x = state.bundle_target) == null ? void 0 : _x.target}` : utils.formatMoney((_y = state.bundle_target) == null ? void 0 : _y.target);
    state.current_wording = bundle_type === "item_count" ? `${state.item_count}` : utils.formatMoney(state.total_price);
    state.difference_wording = bundle_type === "item_count" ? `${((_z = state.bundle_target) == null ? void 0 : _z.target) - state.item_count}` : utils.formatMoney(((_A = state.bundle_target) == null ? void 0 : _A.target) - state.total_price);
    state.selling_plan_discount_wording_old = state.subscription_price < state.discounted_price ? `Save ${utils.formatMoney(state.discounted_price - state.subscription_price)}` : "";
    state.selling_plan_discount_wording = ((_B = state.bundle_target) == null ? void 0 : _B.discount_amount) ? `Save ${utils.formatMoney((_C = state.bundle_target) == null ? void 0 : _C.discount_amount)}` : ((_D = state == null ? void 0 : state.bundle_target) == null ? void 0 : _D.discount_percentage) ? `${(_E = state == null ? void 0 : state.bundle_target) == null ? void 0 : _E.discount_percentage}% off` : "";
    state.target_discount_wording = ((_F = state.bundle_target) == null ? void 0 : _F.discount_amount) ? `Save ${utils.formatMoney((_G = state.bundle_target) == null ? void 0 : _G.discount_amount)}` : ((_H = state == null ? void 0 : state.bundle_target) == null ? void 0 : _H.discount_percentage) ? `${(_I = state == null ? void 0 : state.bundle_target) == null ? void 0 : _I.discount_percentage}% off` : "";
    const basePrice = state.before_discounts_price;
    state.discount_wording = basePrice > 0 ? `${utils.roundToIndex((1 - state.final_price / basePrice) * 100, 0)}% off` : "0% off";
    state.active_target_discount_wording = state.total_price > state.final_price ? state.target_discount_wording : "";
    state.active_discount_wording = state.total_price > state.final_price ? state.discount_wording : "";
    state.item_added_summary = (_J = state == null ? void 0 : state.items_added) == null ? void 0 : _J.reduce((acc, item) => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g3;
      const addedIndex = acc.findIndex((item2) => {
        var _a4, _b4;
        return ((_a4 = item == null ? void 0 : item.variant) == null ? void 0 : _a4.id) === ((_b4 = item2 == null ? void 0 : item2.variant) == null ? void 0 : _b4.id);
      });
      if (addedIndex !== -1 && item.price_override === acc[addedIndex]["price_override"]) {
        acc[addedIndex]["quantity"] += 1;
      } else {
        const selling_plan = (_b3 = (_a3 = item.variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
          (plan) => {
            var _a4;
            return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.name) === state.selected_selling_plan;
          }
        );
        acc.push({
          quantity: 1,
          subscription: (_e3 = (_d3 = (_c3 = selling_plan == null ? void 0 : selling_plan.selling_plan) == null ? void 0 : _c3.options) == null ? void 0 : _d3.at(-1)) == null ? void 0 : _e3.value,
          price: (_g3 = selling_plan == null ? void 0 : selling_plan.price) != null ? _g3 : (_f3 = item.variant) == null ? void 0 : _f3.price,
          compare_at_price: selling_plan == null ? void 0 : selling_plan.compare_at_price,
          ...item
        });
      }
      return acc;
    }, []);
    state.bundle_target_titles = getTargetTitles();
  });
  const updateBundleById = /* @__PURE__ */ __name((bundle_id = state.bundle_target_id) => {
    var _a2, _b2, _c2, _d2;
    state.bundle_target_id = bundle_id;
    if (state.bundle_target_id || ((_a2 = state.items_added) == null ? void 0 : _a2.length)) {
      state.bundle_target = (_b2 = bundle_targets.find((target) => {
        var _a3;
        if (bundle_type === "item_count") {
          return target.id === state.bundle_target_id && target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
        } else {
          return target.id === state.bundle_target_id;
        }
      })) == null ? void 0 : _b2.settings;
      if (!state.bundle_target && (bundle_targets == null ? void 0 : bundle_targets.length)) {
        const bundle_target = (_d2 = [...bundle_targets].sort((a, b) => a.settings.target - b.settings.target).find((target) => {
          var _a3;
          if (bundle_type === "item_count") {
            return target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
          } else {
            return true;
          }
        })) != null ? _d2 : (_c2 = [...bundle_targets].sort((a, b) => b.settings.target - a.settings.target)) == null ? void 0 : _c2[0];
        state.bundle_target = bundle_target == null ? void 0 : bundle_target.settings;
        state.bundle_target_id = bundle_target == null ? void 0 : bundle_target.id;
      }
    }
  }, "updateBundleById");
  const addToBundle = /* @__PURE__ */ __name(({
    product,
    variant,
    price
  }) => {
    var _a2, _b2, _c2;
    if ((variant == null ? void 0 : variant.inventory_management) && (variant == null ? void 0 : variant.inventory_policy) !== "continue") {
      const quantity_added = state.items_added.reduce((acc, item) => {
        var _a3;
        if (((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === variant.id) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (variant.inventory_quantity - quantity_added < 1) {
        _stores.toast.addToast({
          type: "error",
          title: "Not enough inventory",
          content: "It looks like you already added the item and the inventory limit has been reached."
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "hard_limit") {
      if ((state == null ? void 0 : state[bundle_type]) < ((_a2 = state.bundle_target) == null ? void 0 : _a2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      }
      return;
    }
    if (section_settings.restrict_bundle_quantity === "upgrade_limit") {
      const lastBundleTarget = (_b2 = [...bundle_targets].sort((a, b) => {
        var _a3, _b3;
        return ((_a3 = a == null ? void 0 : a.settings) == null ? void 0 : _a3.target) - ((_b3 = b == null ? void 0 : b.settings) == null ? void 0 : _b3.target);
      })) == null ? void 0 : _b2.at(-1);
      if ((state == null ? void 0 : state[bundle_type]) < ((_c2 = lastBundleTarget == null ? void 0 : lastBundleTarget.settings) == null ? void 0 : _c2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      } else {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!"
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "no_limit") {
      if ((state == null ? void 0 : state[bundle_type]) < state.max_bundle_quantity) {
        state.items_added.push({ product, variant, price_override: price });
      }
    }
    updateBundleById();
  }, "addToBundle");
  const removeFromBundle = /* @__PURE__ */ __name(({
    product,
    variant
  }) => {
    var _a2, _b2;
    const index = (_b2 = (_a2 = state.items_added.map((item, idx) => ({ item, idx })).reverse().find(({ item }) => {
      var _a3;
      return ((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === (variant == null ? void 0 : variant.id) && item.product.id === product.id;
    })) == null ? void 0 : _a2.idx) != null ? _b2 : -1;
    if (index !== -1) {
      state.items_added.splice(index, 1);
    }
  }, "removeFromBundle");
  const setSellingPlan = /* @__PURE__ */ __name((name) => {
    state.selected_selling_plan = name;
  }, "setSellingPlan");
  const handleAddToCart = /* @__PURE__ */ __name(async (action) => {
    var _a2, _b2, _c2, _d2;
    try {
      state.isAdding = true;
      const data = await _cart.add({
        items: (_a2 = state.items_added) == null ? void 0 : _a2.map((item) => {
          var _a3, _b3, _c3, _d3, _e2, _f2;
          return {
            id: (_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id,
            properties: {
              _bundle_id: random_id,
              Bundle: (_b3 = state.achieved_bundle_target) == null ? void 0 : _b3.label
            },
            quantity: 1,
            selling_plan: (_f2 = (_e2 = (_d3 = (_c3 = item.variant) == null ? void 0 : _c3.selling_plan_allocations) == null ? void 0 : _d3.find(
              (plan) => {
                var _a4;
                return ((_a4 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a4.name) === state.selected_selling_plan;
              }
            )) == null ? void 0 : _e2.selling_plan) == null ? void 0 : _f2.id
          };
        })
      });
      if (data.cart_error) {
        state.isAdding = false;
        return;
      }
      if (action === "add_to_cart") {
        _stores.modal.setId("modal--cart-drawer");
      }
      if (action === "checkout") {
        (_b2 = document.querySelector('[data-cart-drawer-checkout-form] button[name="checkout"]')) == null ? void 0 : _b2.click();
        state.isAdding = false;
        state.items_added_to_cart = true;
        await utils.delay(3500);
        state.items_added_to_cart = false;
        return;
      }
      state.items_added = [];
      state.bundle_target_id = (_c2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _c2.id;
      state.total_price = 0;
      state.discounted_price = 0;
      state.final_price = 0;
      state.subscription_price = 0;
      state.selling_plan_discount_wording = "";
      state.discount_wording = "";
      state.item_count = 0;
      state.target_difference = "";
      state.selling_plan_options = selling_plan_options;
      state.selected_selling_plan = null;
      state.bundle_target = (_d2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _d2.settings;
      state.achieved_bundle_target = null;
      state.incentive_target = incentive_targets == null ? void 0 : incentive_targets[0];
      state.selling_plan_duration = "";
      state.isAdding = false;
      state.show_mobile_details = false;
      state.max_bundle_quantity = section_settings.max_bundle_quantity;
      state.items_added_to_cart = true;
      await utils.delay(3500);
      state.items_added_to_cart = false;
    } catch (error) {
      console.log(error);
    }
  }, "handleAddToCart");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "opened":
        return state.show_mobile_details;
      case "closed":
        return !state.show_mobile_details;
      case "always": {
        return true;
      }
    }
  }, "showConditionally");
  const showBasedOnBundleState = /* @__PURE__ */ __name((show_based_on_bundle_state) => {
    var _a2, _b2;
    if (!show_based_on_bundle_state) {
      return true;
    }
    switch (show_based_on_bundle_state) {
      case "always":
        return true;
      case "bundle_empty":
        return state[bundle_type] === 0;
      case "some_items_added":
        return state[bundle_type] > 0;
      case "items_added":
        return state[bundle_type] > 0 && state[bundle_type] < ((_a2 = state == null ? void 0 : state.bundle_target) == null ? void 0 : _a2.target);
      case "bundle_complete":
        return state[bundle_type] >= ((_b2 = state == null ? void 0 : state.bundle_target) == null ? void 0 : _b2.target);
    }
  }, "showBasedOnBundleState");
  state.addToBundle = addToBundle;
  state.removeFromBundle = removeFromBundle;
  window._sections["bundleSection"] = {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    selling_plan_options,
    addToBundle,
    removeFromBundle,
    setSellingPlan,
    updateBundleById,
    handleAddToCart,
    showConditionally,
    showBasedOnBundleState
  };
  return {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    selling_plan_options,
    addToBundle,
    removeFromBundle,
    setSellingPlan,
    updateBundleById,
    handleAddToCart,
    showConditionally,
    showBasedOnBundleState
  };
}, "initBundle");
window._sections["initBundle"] = initBundle;
